import { formatPhoneDisplay, prefixForCountryId } from "../components/phoneField"

/*
	Un teléfono se ve de UNA sola forma en toda la app (Esteban, 2026-09-22): el número del país
	del plantel se muestra agrupado y SIN el código ("81 9492 3602"); el de otro país lleva su
	prefijo delante ("+1 305 555 0143"). Nunca los dos a la vez, y nunca el número pegado tal
	como está guardado en la base.

	Es una envoltura sobre formatPhoneDisplay para que las pantallas no tengan que resolver el
	prefijo del plantel cada vez.
*/
export const telefonoBonito = (valor: any, paisDelPlantel?: number): string =>
{
	const texto = String(valor ?? "").trim()

	if(texto === "")
	{
		return ""
	}

	return formatPhoneDisplay(texto, prefixForCountryId(paisDelPlantel)) || texto
}

/** Varios números en una línea, separados por " / ", saltando los vacíos. */
export const telefonosBonitos = (valores : any[], paisDelPlantel?: number) : string =>
	valores.map(v => telefonoBonito(v, paisDelPlantel)).filter(v => v !== "").join(" / ")

export default telefonoBonito

/*
	Siempre con lada ("+504 9676-1966", "+52 81 9492 3602"): WappChat mezcla clientes de Honduras y de México, y las
	asesoras copian el número para buscarlo en otros lados (Esteban, 2026-09-30). Barrido 26-oct-2026: el hondureño salía
	sin +504 en un plantel de México y no se sabía de qué país era.
*/
export const telefonoConLada = (valor: any): string =>
{
	const texto = String(valor ?? "").trim()
	return texto === "" ? "" : formatPhoneDisplay(texto, "0") || texto
}
